document.addEventListener("DOMContentLoaded", () => {
    const container = document.getElementById("drawing-tool");
    if (container) {
        const necklaces = [
            {
                name: "Halskæde 1",
                src: container.dataset.necklace1.replace('/files/files/', '/files/')
            },
            {
                name: "Halskæde 2",
                src: container.dataset.necklace2.replace('/files/files/', '/files/')
            },
            {
                name: "Halskæde 3",
                src: container.dataset.necklace3.replace('/files/files/', '/files/')
            }
        ].filter(necklace => necklace.src !== "");

        if (necklaces.length === 0) {
            container.innerHTML = "<p>Vælg venligst mindst ét halskæde billede i Theme Editor.</p>";
            return;
        }

        // Clear old content
        container.innerHTML = "";

        // Create title
        const title = document.createElement("h2");
        title.textContent = "Design din halskæde";
        title.style.textAlign = "center";
        title.style.fontSize = "2rem";
        title.style.fontWeight = "bold";
        title.style.marginBottom = "20px";
        container.appendChild(title);

        // Create canvas wrapper
        const canvasWrapper = document.createElement("div");
        canvasWrapper.classList.add('canvas-wrapper');
        canvasWrapper.style.position = "relative";
        canvasWrapper.style.width = "350px";
        canvasWrapper.style.height = "350px";
        canvasWrapper.style.margin = "0 auto";
        container.appendChild(canvasWrapper);

        // Create background image
        const bgImage = new Image();
        bgImage.src = necklaces[0].src;
        bgImage.classList.add('bg-image');
        bgImage.style.position = "absolute";
        bgImage.style.width = "auto";
        bgImage.style.height = "auto";
        bgImage.style.maxWidth = "100%";
        bgImage.style.maxHeight = "100%";
        bgImage.style.objectFit = "contain";
        bgImage.style.top = "0";
        bgImage.style.left = "0";
        bgImage.style.top = "0";
        bgImage.style.left = "0";
        bgImage.style.zIndex = "1";
        canvasWrapper.appendChild(bgImage);

        // Create drawing canvas
        const canvas = document.createElement("canvas");
        canvas.classList.add('drawing-canvas');
        canvas.width = 350;
        canvas.height = 350;
        canvas.style.position = "absolute";
        canvas.style.top = "0";
        canvas.style.left = "0";
        canvas.style.zIndex = "2";
        canvas.style.backgroundColor = "transparent";
        canvasWrapper.appendChild(canvas);

        const ctx = canvas.getContext("2d");

        // Create thumbnail selector
        const thumbnailWrapper = document.createElement("div");
        thumbnailWrapper.style.display = "flex";
        thumbnailWrapper.style.gap = "10px";
        thumbnailWrapper.style.marginTop = "20px";
        thumbnailWrapper.style.marginBottom = "20px";
        thumbnailWrapper.style.justifyContent = "center";
        container.appendChild(thumbnailWrapper);

        necklaces.forEach((necklace, index) => {
            const thumbnail = document.createElement("img");
            thumbnail.src = necklace.src;
            thumbnail.style.width = "80px";
            thumbnail.style.height = "80px";
            thumbnail.style.objectFit = "cover";
            thumbnail.style.cursor = "pointer";
            thumbnail.style.borderRadius = "8px";
            thumbnail.style.border = index === 0 ? "2px solid black" : "2px solid transparent";
            thumbnail.addEventListener("click", () => {
                bgImage.src = necklace.src;
                // Highlight selected thumbnail
                document.querySelectorAll('.thumbnail').forEach(img => img.style.border = "2px solid transparent");
                thumbnail.style.border = "2px solid black";
            });
            thumbnail.classList.add('thumbnail');
            thumbnailWrapper.appendChild(thumbnail);
        });

        // Create save button
        const saveButton = document.createElement("button");
        saveButton.textContent = "Download";
        saveButton.style.backgroundColor = "#000";
        saveButton.style.color = "#fff";
        saveButton.style.fontSize = "1.2rem";
        saveButton.style.fontWeight = "bold";
        saveButton.style.padding = "10px 20px";
        saveButton.style.borderRadius = "8px";
        saveButton.style.border = "none";
        saveButton.style.cursor = "pointer";
        saveButton.style.marginTop = "20px";
        saveButton.style.marginBottom = "20px";
        saveButton.classList.add('save-button');
        saveButton.style.display = "block";
        saveButton.style.margin = "20px auto";
        container.appendChild(saveButton);

        // Create reset button
        // Create reset link
        const resetLink = document.createElement("a");
        resetLink.textContent = "Nulstil";
        resetLink.style.color = "#555";
        resetLink.style.fontSize = "1rem";
        resetLink.style.fontWeight = "normal";
        resetLink.style.cursor = "pointer";
        resetLink.style.textAlign = "center";
        resetLink.style.display = "block";
        resetLink.style.margin = "10px auto";
        resetLink.classList.add('reset-link');
        container.appendChild(resetLink);

        // Reset canvas on link click
        resetLink.addEventListener("click", () => {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
        });

        // Reset canvas on link click
        resetLink.addEventListener("click", () => {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
        });

        // Save drawing without background
        saveButton.addEventListener("click", () => {
            const tempCanvas = document.createElement("canvas");
            tempCanvas.width = 350;
            tempCanvas.height = 350;
            const tempCtx = tempCanvas.getContext("2d");
            tempCtx.drawImage(canvas, 0, 0, 350, 350);
            const link = document.createElement("a");
            link.href = tempCanvas.toDataURL("image/png");
            link.download = `custom-drawing-${Date.now()}.png`;
            link.click();
        });

        // Drawing logic
        let drawing = false;

        const startDrawing = (x, y) => {
            drawing = true;
            ctx.beginPath();
            ctx.moveTo(x, y);
        };

        const draw = (x, y) => {
            if (!drawing) return;
            ctx.lineTo(x, y);
            ctx.strokeStyle = "#000";
            ctx.lineWidth = 4;
            ctx.lineCap = "round";
            ctx.lineJoin = "round";
            ctx.stroke();
        };

        const stopDrawing = () => {
            drawing = false;
        };

        // Mouse events
        canvas.addEventListener("mousedown", (e) => {
            const rect = canvas.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;
            startDrawing(x, y);
        });

        canvas.addEventListener("mousemove", (e) => {
            const rect = canvas.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;
            draw(x, y);
        });

        canvas.addEventListener("mouseup", stopDrawing);
        canvas.addEventListener("mouseleave", stopDrawing);

        // Touch events
        canvas.addEventListener("touchstart", (e) => {
            const rect = canvas.getBoundingClientRect();
            const touch = e.touches[0];
            const x = touch.clientX - rect.left;
            const y = touch.clientY - rect.top;
            startDrawing(x, y);
            e.preventDefault();
        });

        canvas.addEventListener("touchmove", (e) => {
            const rect = canvas.getBoundingClientRect();
            const touch = e.touches[0];
            const x = touch.clientX - rect.left;
            const y = touch.clientY - rect.top;
            draw(x, y);
            e.preventDefault();
        });

        canvas.addEventListener("touchend", stopDrawing);
        canvas.addEventListener("touchcancel", stopDrawing);
    }
});
